import { skipToken } from "@reduxjs/toolkit/query";
import { styled } from "styled-components";

import { topicsApiSlice } from "api/topicsApi.slice";
import { ListItemBox } from "common/components";
import type { EditListItemProps } from "domains/topic/components/EditListItem";
import { EditListItem } from "domains/topic/components/EditListItem";

type KeyIssueTileProps = Omit<EditListItemProps, "subtitle"> & { parent_topic_id?: string };

const StyledListItemBox = styled(ListItemBox)`
  padding: 1rem;
  margin-bottom: 1rem;
`;

export const KeyIssueTile = ({
  image_url,
  parent_topic_id,
  isDescriptionExpanded,
  onToggleDescription,
  ...props
}: KeyIssueTileProps) => {
  const arg = parent_topic_id === undefined ? skipToken : { id: parent_topic_id };
  const { data } = topicsApiSlice.endpoints.getTopic.useQuery(arg);

  return (
    <StyledListItemBox>
      <EditListItem
        {...props}
        image_url={image_url ?? data?.images?.x_small}
        subtitle={data?.name}
        isDescriptionExpanded={isDescriptionExpanded}
        onToggleDescription={onToggleDescription}
      />
    </StyledListItemBox>
  );
};
